import { atom } from 'jotai';

export type Client = {
  id: number;
  clientName: string;
  clientSurname: string;
  investmentType: string;
};

export type ReportFormData = {
  clients: Client[];
  period: { start: Date | Date[]; end: Date | Date[] };
  notes: string;
  reportType: 'investmentReport' | 'investmentOverview';
  selectedOptions: string[];
};

export const defaultFormData: ReportFormData = {
  clients: [],
  period: { start: new Date(), end: new Date() },
  notes: '',
  reportType: 'investmentReport',
  selectedOptions: []
};

export const reportFormAtom = atom<ReportFormData>(defaultFormData);
